export const getReservationMagasinData = state => state.reservationMagasinContent;
